export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14449.91da10b8.jpg";